import { render, staticRenderFns } from "./flowCenter.vue?vue&type=template&id=ebdaaf60&scoped=true"
import script from "./flowCenter.vue?vue&type=script&lang=js"
export * from "./flowCenter.vue?vue&type=script&lang=js"
import style0 from "./flowCenter.vue?vue&type=style&index=0&id=ebdaaf60&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdaaf60",
  null
  
)

export default component.exports